import { inject, Injectable } from '@angular/core';
import { StandardDialogService } from '@components/standard-dialog';
import { TranslatorService } from '@shared/services';
import { DELETE_DIALOG_TRAD_KEY, RESET_DIALOG_TRAD_KEY } from '@wizard/constants';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WizardPanelDialogService {

  /** @Inject */
  private readonly translator = inject(TranslatorService);
  private readonly dialog = inject(StandardDialogService);

  constructor() { }

  clearBasketDialog(): Observable<any> {
    return this.openDialog({
      type: 'danger',
      icon: 'warning_amber',
      title: this.translator.instant(`${RESET_DIALOG_TRAD_KEY}.Title`),
      messages: [this.translator.instant(`${RESET_DIALOG_TRAD_KEY}.Message`)]
    });
  }

  deleteBasketDialog(): Observable<any> {
    return this.openDialog({
      type: 'warn',
      icon: 'warning_amber',
      title: this.translator.instant(`${DELETE_DIALOG_TRAD_KEY}.Title`),
      messages: [this.translator.instant(`${DELETE_DIALOG_TRAD_KEY}.Message`)]
    });
  }

  private openDialog(data: any): Observable<any> {
    return this.dialog.open({ data }).afterClosed();
  }
}
